import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
// import { MsalService } from '@azure/msal-angular';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Const } from '../static/const';
// import {
//   AppPopupComponent,
//   AppPopupData,
//   PopupType,
// } from '../widgets/app-popup/app-popup.component';
// import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private dialog: MatDialog,
    protected http: HttpClient // private msalService: MsalService,
  ) // private storageService: StorageService
  {}

  get(url: string, params?: any, headers?: any, silent?: any): Observable<any> {
    return this.http
      .get(url, { headers: headers, params })
      .pipe(catchError((err) => this.handleError(err, silent)));
  }

  post(url: string, data: any, headers?: any, silent?: any): Observable<any> {
    const requestData =
      data instanceof ArrayBuffer ? data : JSON.stringify(data);
    return this.http
      .post(url, requestData, { headers: headers })
      .pipe(catchError((err) => this.handleError(err, silent)));
  }

  uploadFile(
    url: string,
    data: any,
    headers?: any,
    silent?: any
  ): Observable<any> {
    return this.http
      .post(url, data, { headers: headers })
      .pipe(catchError((err) => this.handleError(err, silent)));
  }

  // put(url: string, data: any, headers?: any, silent?: any): Observable<any> {
  //   return this.prepareHeaders(headers).pipe(
  //     switchMap((resHeaders) => {
  //       if (!resHeaders) {
  //         return throwError('No request headers presented');
  //       }
  //       const requestData =
  //         data instanceof ArrayBuffer ? data : JSON.stringify(data);
  //       return this.http
  //         .put(url, requestData, { headers: resHeaders })
  //         .pipe(catchError((err) => this.handleError(err, silent)));
  //     })
  //   );
  // }

  // delete(
  //   url: string,
  //   params?: any,
  //   headers?: any,
  //   silent?: any
  // ): Observable<any> {
  //   return this.prepareHeaders(headers).pipe(
  //     switchMap((resHeaders) => {
  //       if (!resHeaders) {
  //         return throwError('No request headers presented');
  //       }
  //       return this.http
  //         .delete(url, { headers: resHeaders, params })
  //         .pipe(catchError((err) => this.handleError(err, silent)));
  //     })
  //   );
  // }

  // private prepareHeaders(
  //   headers: HttpHeaders,
  //   multipart?: boolean
  // ): Observable<HttpHeaders> {
  //   return from(this.checkAuthToken(headers)).pipe(
  //     tap((headersWithAuth) => {
  //       if (headersWithAuth) {
  //         if (!headersWithAuth.has(Const.httpHeaderContentType) && !multipart) {
  //           headersWithAuth = headersWithAuth.set(
  //             Const.httpHeaderContentType,
  //             Const.httpHeaderContentTypeVal
  //           );
  //         }
  //         if (!headersWithAuth.has(Const.httpHeaderAccept)) {
  //           headersWithAuth = headersWithAuth.set(
  //             Const.httpHeaderAccept,
  //             Const.httpHeaderAcceptVal
  //           );
  //         }
  //       }
  //     })
  //   );
  // }

  // public async checkAuthToken(headers: HttpHeaders): Promise<any> {
  //   let account: any;
  //   try {
  //     account = this.msalService.instance.getAllAccounts()[0];
  //   } catch (err) {}
  //   const request: any = {
  //     scopes: ['openid', 'profile', 'User.Read', 'email'],
  //   };

  //   const token = sessionStorage.getItem('authToken');

  //   if (token) {
  //     return headers.set(Const.httpHeaderAuth, Const.authBearerPrefix + token);
  //   } else {
  //     return undefined;
  //   }
  // }

  private handleError(error: HttpErrorResponse, silent: boolean) {
    if (silent) {
      return throwError(error);
    }
    let message: string;
    switch (+error.status) {
      case Const.mlTooLongErrorCode:
        message = 'ERRORS.ML_TOO_LONG';
        break;
      default:
        message = 'ERRORS.ERROR_SENDING_DATA';
    }
    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.data = {
    //   message,
    //   icon: './assets/img/icons/connection-error-icon.svg',
    //   buttons: [{ id: 'OK', text: 'COMMON.OK' }],
    //   submitButtonId: 'OK',
    //   type: PopupType.ERROR,
    // } as AppPopupData;
    // this.dialog.open(AppPopupComponent, dialogConfig);
    return throwError(error);
  }
}
